import {
    peopleFeedbackCheckboxNoResult,
    peopleFeedbackCheckboxSearchSlow,
    peopleFeedbackCheckboxResultNotRelevent,
    peopleFeedbackCheckboxItemNotInResult,
    peopleFeedbackCheckboxSugNotUseful,
    peopleFeedbackCheckboxHardToUse,
    peopleFeedbackCheckboxOther,
} from './feedbackCheckboxContent.locstring.json';
import loc from 'owa-localize';

export default function() {
    return [
        {
            label: loc(peopleFeedbackCheckboxNoResult),
            name: 'noResult',
        },
        {
            label: loc(peopleFeedbackCheckboxSearchSlow),
            name: 'searchSlow',
        },
        {
            label: loc(peopleFeedbackCheckboxResultNotRelevent),
            name: 'resultNotRelevent',
        },
        {
            label: loc(peopleFeedbackCheckboxItemNotInResult),
            name: 'itemNotInResult',
        },
        {
            label: loc(peopleFeedbackCheckboxSugNotUseful),
            name: 'sugNotUseful',
        },
        {
            label: loc(peopleFeedbackCheckboxHardToUse),
            name: 'hardToUse',
        },
        {
            label: loc(peopleFeedbackCheckboxOther),
            name: 'other',
        },
    ];
}
